import React, { useEffect, useState } from "react";
import { useLocation } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { InfoControl } from '../../RIValidation/components/InfoControl';
import { ContratosPaciente } from '../../RIValidation/components/ContratosPaciente';
import { DireccionContent } from "../../RIValidation/components/DireccionContent";
import { AptoInput } from "../../RIValidation/components/AptoInput";
import { useGetActions } from "../hooks/useGetActions";

export const RICambioProgramaContent = ({ setChildrenAction }) => {
    const location = useLocation();
    const stateData = location.state;
    const { notificationData, tipoNotificacion, idDelegacion, idTipoModulo } = stateData;
    const [notification, setNotification] = useState(notificationData || {});
    const [apto, setApto] = useState(false);
    const [contratosIds, setContratosIds] = useState([]);

    const handleChange = (name, value) => {
        setNotification(prevDatos => ({
            ...prevDatos,
            [name]: value
        }));
    }

    const { handleClickValidar, loading: buttonActionLoading } = useGetActions({ handleChange, notification });

    useEffect(() => {
        if (!notification) return setChildrenAction(null);

        setChildrenAction(() => (
            (notification.estadoValidacion !== 'Validado' && <div className='top-buttons'>
                {/* hacer version de aptoInput para cambio programa */}
                <div className='margin-right'>
                    <AptoInput
                        idEvaluacion={notification?.idEvaluacion}
                        handleClickAceptar={(rechazo) => handleClickValidar(rechazo)}
                        loadingValidar={buttonActionLoading}
                        isReject={true}
                    />
                </div>
                <div className='margin-right'>
                    <AptoInput
                        idEvaluacion={notification?.idEvaluacion}
                        handleClickAceptar={(rechazo) => handleClickValidar(rechazo)}
                        loadingValidar={buttonActionLoading}
                    />
                </div>
            </div>)
        ))
    }, [notification, buttonActionLoading, apto]);

    return <>
        
        <InfoControl
            notification={notification}
            tipoNotificacion={tipoNotificacion}
        />
        <DireccionContent
            notification={notification}
            setApto={setApto}
        />
        <ContratosPaciente
            idPaciente={notification?.hC}
            setContratosIds={setContratosIds}
        />
    </>
}